export default {
  STEP_1:{
    TITLE:'Who will be appointed to the various corporate positions of the company and act as the initial sole incorporator?',
    SUBTITLE:'Edit corporate positions',
    SUBTITLE_ADD:'Corporate positions',
    TOOLTIP: "A Delaware formation requires a sole incorporator (an individual to sign the initial documents) and the following corporate positions to be appointed:<br><br>- President<br>- Chief Executive Officer<br>- Treasurer<br>- Secretary<br><br>For a simple and efficient process, we only require you to select one individual to perform the role of sole incorporator and occupy all of the above positions."
  },
}